import React, { useEffect, useMemo, useState, useContext } from 'react'
import PatientService from '../../../../../../services/api/patient.service'
import moment from 'moment'
import { Dropdown, Accordion, Icon } from 'semantic-ui-react'
import ModalBox from '../../../../../templates/components/ModalBox'
import EditPatient from '../../edit-patient/EditPatient'
import AddAppointmentForm from '../../../appointment/add-appointment-form/AddAppointmentForm'
import NoteAdd from '../../../note/note-add/NoteAdd'
import { store } from "../../../../../../context/StateProvider";


// Accordion Imports
import AppointmentList from "../patient-card/appointment-list/AppointmentList";
import ContactDetails from '../patient-card/contact-details/ContactDetails';
import FormsList from "../patient-card/forms/forms-list/FormsList"
import OpenBalancesList from '../patient-card/open-balances/open-balances-list/OpenBalancesList';
import TransactionHistoryList from "../patient-card/transactions-list/TransactionHistoryList"
import WalletList from "../patient-card/wallet/wallet/WalletList"


import PatientAccountAdd from '../../../patient-account/patient-account-add/PatientAccountAdd'
import { useNavigate } from 'react-router-dom'
import Utilities from '../../../../../../services/commonservice/utilities'
import PCNoteList from './pc-note-list/PCNoteList'
import AddInvoice from '../../../invoices/add-invoice/AddInvoice'
import AddForms from '../../add-forms/AddForms'
import PaymentPlanList from './plan-list/PaymentPlanList'

import toast from 'react-hot-toast'
import PatientOptInOut from '../../patient-optinout/PatientOptInOut'
import PlFormsService from '../../../../../../services/api/plforms.service'
import CommunicationList from './communication-list/CommunicationList'
import DocumentList from './document-list/DocumentList'
import AddDocuments from './document-list/AddDocuments'
import MembershipList from './membership-list/MembershipList'
import TreatmentPlanList from './treatment-plan-list/TreatmentPlanList'
import TreatmentPlanAdd from '../../../treatment-plan/treatment-plan-add/TreatmentPlanAdd'
import ChartNotesHistoryTable from '../../../appointment/charting/ChartNotesHistoryTable'
import SoapNotesList from './soap-notes-list/SoapNotesList'
import SoapNotesAdd from '../../patient-soap-notes/soap-notes-add/SoapNotesAdd'
import TranscriptsPanel from '../../../appointment/charting/TranscriptsPanel'
import CombinePatients from '../../combine-patients/CombinePatients'

const   PatientCard = (props) => {
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const [showMore, setShowMore] = useState(false)
    const [keyword, setKeyword] = useState(props.keyword || null)
    const [showAddAppointment, setShowAddAppointment] = useState(false)
    const [showAddPaymentAccount, setShowAddPaymentAccount] = useState(false)
    const [showProcessPayment, setShowProcessPayment] = useState(false)
    const [activeIndex, setActiveIndex] = useState()
    const [patient, setPatient] = useState(props.patient)
    const [showDeactivate, setShowDeactivate] = useState(false)
    const [forms, setForms] = useState()
    const [balance, setBalance] = useState()
    const [patientTags, setPatientTags] = useState()
    const [contactDetailsAdd, setContactDetailsAdd] = useState(false)
    const [noteAdd, setNoteAdd] = useState(false)
    const [showAddForms, setShowAddForms] = useState(false)
    const [showAddDocuments, setShowAddDocuments] = useState(false)
    const [optInLocale, setOptInLocale] = useState()
    const [showOpt, setShowOpt] = useState(false)
    const [refresh, setRefresh] = useState()
    const [contactDetails, setContactDetails] = useState()
    const [alwaysExpanded, setAlwaysExpanded] = useState(props.alwaysExpanded)
    const [treatmentPlansAdd, setTreatmentPlansAdd] = useState(false)
    const [showSoapNotesAdd, setShowSoapNotesAdd] = useState(false)
    const [showCombinePatient, setShowCombinePatient] = useState(false)
    const navigate = useNavigate();


    const formRetrieve = () => {
        let reqObj = {
            PatientIds: props.id
        }
        PlFormsService.getMapFormsWithPatient(reqObj)
            .then(res => {
                if (res?.data?.length > 0) {
                    // console.log(res?.data[0].formIds)
                    setForms(res?.data[0].formIds)
                }
            })
    }

    const findPatient = () => {
        PatientService.getPatientById(props.id)
            .then(res => {
                if (res?.data) {
                    //console.log(res.data)
                    setPatient(res.data)
                }
            })
    }

    const setIndex = (i) => {
        if (i === activeIndex) {
            setActiveIndex()
        }
        else {
            setActiveIndex(i)
        }
    }

    const toggleShowAddForms = (e) => {
        e.preventDefault();
        setShowAddForms(false)
    }

    const deactivate = (id) => {
        PatientService.inactivatePatient(props.id)
            .then(res => { return res.data })
    }

    useEffect(() => {
        if (refresh == true) {
            if (props.refresh) {
                props.refresh()
            }
            findPatient()
            formRetrieve()
            return setRefresh(false)
        }
    }, [refresh])

    useEffect(() => {
        setKeyword(props.keyword)
    }, [props.keyword])

    useEffect(() => {
        if (props?.forms && props?.forms.length>0) {
            setForms(props.forms[0].formIds)
        }
    }, [props.forms])
    useEffect(() => {
        if (props?.patientTags && props?.patientTags.length>0) {    
            setPatientTags(props.patientTags[0].patientTags)
        }
    }, [props.patientTags])

    useEffect(() => {
        if (props?.balance && props?.balance.length>0) {
            let total = 0
            props?.balance.forEach(obj => { if (obj?.amountPaid) { total += obj.finalAmount - obj.amountPaid } else { total += obj.finalAmount } })
            setBalance(total)
        }
    }, [props?.balance])

    const creditBalance = useMemo(()=>{
        if(props.creditBalance?.length>=1){
            const total = props.creditBalance.reduce((sum, record) => sum + (record?.currentBalance || 0), 0);
            return {
                total,
                records: props.creditBalance
            };
        }
        return null;
    },[props.creditBalance])
    return (
        <div className='container-flex card mb-3 bg-light patient-card'>
            {patient &&
                <div className='row d-flex p-3'>
                    <div className='col-12 row-fluid d-flex justify-content-between'>
                        <div className='col row d-flex align-items-start'>
                            <div className='col point text-start patient-card-header' onClick={e => { e.preventDefault(); setShowMore(!showMore) }}>
                                <div className='row d-flex align-items-center justify-content-between'>
                                    <div className='col-md-auto col-12'>
                                        <h5><div className='d-flex row align-items-center'>
                                            <div className='col-auto'>
                                                <strong>{patient.firstName} {patient.lastName}</strong>
                                            </div>
                                        </div>
                                        </h5>
                                    </div>
                                    <div className='col-md col-sm-12'>
                                        {forms && forms.map((form,i) => {
                                            return (
                                                <span className={`badge text-white me-1 ${form.status === 0 ? 'bg-danger' : 'bg-success'}`} key={i}>{form.formTitle}</span>
                                            )
                                        })}
                                    </div>
                                    <div className="col-md-auto col-12">
                                        <div className='btn-group'>
                                            {state.permissions.paymentsModifyInvoices && <button className='btn btn-primary' title="Collect Payment from Patient" onClick={e => { e.preventDefault(); setShowProcessPayment(true) }}><i className={`icon dollar`} /></button>}
                                            {state.permissions.patientModifyPatients && <button className='btn btn-primary' title="Edit Patient" onClick={e => { e.preventDefault(); setContactDetailsAdd(true) }}><i className={`icon pencil`} /></button>}
                                            {state.permissions.patientModifyNotes && <button className='btn btn-primary' title="Add a Patient Note" onClick={e => { e.preventDefault(); setNoteAdd(true) }}><i className={`icon sticky note outline`} /></button>}
                                            {state.permissions.schedulingModifyAppointments && <button className='btn btn-primary' title="Add Appointment for Patient" onClick={e => { e.preventDefault(); setShowAddAppointment(true) }}><i className={`icon calendar plus outline`} /></button>}
                                            <Dropdown button direction="left" icon="ellipsis horizontal" className="btn-primary icon btn p-o">
                                                <Dropdown.Menu>
                                                    {state.permissions.patientModifyPatients && <Dropdown.Item onClick={e => { e.preventDefault(); findPatient(); return setShowOpt(true) }}>{patient.isOptIn === 1 ? 'Opt Out' : 'Opt In'} for Notifications</Dropdown.Item>}
                                                    {state.permissions.patientModifyWallet && <Dropdown.Item onClick={e => { e.preventDefault(); setShowAddPaymentAccount(true) }}>Add Payment Account</Dropdown.Item>}
                                                    {state.permissions.patientModifyPatients && <Dropdown.Item onClick={e => { e.preventDefault(); setShowCombinePatient(true) }}>Combine Patient</Dropdown.Item>}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                                {patientTags && <div className='row' style={{padding:'0 0 10px 0'}}>
                                <div className='col-md-auto col-12'>
                                        {patientTags.map((tag,i) => {
                                            return (
                                                <span className={`badge text-white me-1 bg-info`} key={i}>{tag.name}</span>
                                            )
                                        })}
                                    </div>
                                </div>}
                                <div className='row'>
                                    <div className='col-12 row d-flex'>
                                        {balance ? <div className='col-md-3 col-12 patient-card-header-info'>
                                            <span className='text-icon'>O</span> {Utilities.toDollar(balance)}
                                        </div> : null}
                                        {creditBalance?.total > 0 ? <div className='col-md-3 col-12 inline-block text-truncate patient-card-header-info' title={creditBalance.records.filter(record => (record?.currentBalance || 0) > 0).map(record => `${record.description || 'Credit Balance'}: ${Utilities.toDollar(record.currentBalance)}`).join('\n')}>
                                            <span className='text-icon'>P</span> {Utilities.toDollar(creditBalance.total)}
                                        </div> : null}
                                    </div>
                                    <div className='col-12 row d-flex'>
                                        <span className='col-md-3 col-12 d-inline-block text-truncate patient-card-header-info'><i className='icon birthday cake' /> {moment.utc(patient.dob).format("M/D/YYYY")}</span>
                                        {/* <span className='col-md-3 col-12 d-inline-block text-truncate patient-card-header-info'>
                                            <strong>SSN </strong>
                                            {patient.ssn || '----'}
                                        </span> */}
                                        {state.permissions.patientContactInfo && <>
                                        <span className='col-md-3 col-12 d-inline-block text-truncate patient-card-header-info'><i className='icon envelope' />{patient.email || '----'}</span>
                                        <span className='col-md-3 col-12 d-inline-block text-truncate patient-card-header-info'><i className='icon phone' /> {patient.phone && Utilities.toPhoneNumber(patient.phone) || patient.mobile && Utilities.toPhoneNumber(patient.mobile) || '----'}</span>
                                        </>}
                                        <div className='col-md-3 col-12 align-items-center patient-card-header-info'>
                                            {patient.isOptIn == 1 ?
                                                <span className='align-items-center'>
                                                    <i className='col-auto icon check' title="Opted In" /><span className='col-auto'>Opted in for mobile</span>
                                                    </span>
                                                : patient.isOptIn === 0 ? <span className='align-items-center'><i className='col-auto icon dont' title="Opted Out" /><span className='col-auto'>Opted out of mobile</span></span> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(showMore || alwaysExpanded) && <div className='mt-3'>
                        <Accordion fluid styled>
                            {state.permissions.patientContactInfo && <>
                            <Accordion.Title
                                active={activeIndex === 0}
                                index={0}
                                onClick={e => { e.preventDefault(); setIndex(0) }}
                            > <Icon name='dropdown' />Additional Details</Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                {activeIndex === 0 && <ContactDetails patientId={patient.id} patient={patient} keyword={keyword} pull={activeIndex === 0} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.patientViewWallet && <>
                            <Accordion.Title
                                active={activeIndex === 1}
                                index={1}
                                onClick={e => { e.preventDefault(); setIndex(1) }}
                            > <Icon name='dropdown' />Wallet{activeIndex === 1 && state.permissions.patientModifyWallet && <Icon name="plus" title="Add Patient Wallet Details" onClick={e => { e.preventDefault(); setShowAddPaymentAccount(true) }} className='btn p-1 float-right' />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 1}>
                                {activeIndex === 1 && <WalletList patientId={patient.id} refresh={refresh} keyword={keyword} pull={activeIndex === 1} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.patientViewForms && <>
                            <Accordion.Title
                                active={activeIndex === 3}
                                index={3}
                                onClick={e => { e.preventDefault(); setIndex(3) }}
                            > <Icon name='dropdown' />Forms{activeIndex === 3 && state.permissions.patientModifyForms && <Icon patientId={patient.id} name="plus" title="Add Forms to Patient" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setShowAddForms(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 3}>
                                {activeIndex === 3 && <FormsList email={patient.email} patientId={patient.id} patient={patient} keyword={keyword} pull={activeIndex === 3} refresh={refresh} openModal={() => setShowAddForms(true)} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.patientViewNotes && <>
                            <Accordion.Title
                                active={activeIndex === 4}
                                index={4}
                                onClick={e => { e.preventDefault(); setIndex(4) }}
                            > <Icon name='dropdown' />Notes{activeIndex === 4 && state.permissions.patientModifyNotes && <Icon name="plus" title="Add a Patient Note" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setNoteAdd(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 4}>
                                {activeIndex === 4 && <PCNoteList patientId={patient.id} keyword={keyword} pull={activeIndex === 4} refresh={refresh} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.schedulingViewAppointments && <>
                            <Accordion.Title
                                active={activeIndex === 5}
                                index={5}
                                onClick={e => { e.preventDefault(); setIndex(5) }}
                            > <Icon name='dropdown' />Upcoming Appointments{activeIndex === 5 && state.permissions.schedulingModifyAppointments && <Icon name="plus" title="Add Appointment" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setShowAddAppointment(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 5}>
                                {activeIndex === 5 && <AppointmentList patientName={`${patient?.firstName || ""} ${patient?.lastName || ""}`} patientId={patient.id} allLocations={props.allLocations} aptType={'upcoming'} keyword={keyword} pull={activeIndex == 5} refresh={refresh} />}
                            </Accordion.Content>
                            <Accordion.Title
                                active={activeIndex === 13}
                                index={13}
                                onClick={e => { e.preventDefault(); setIndex(13) }}
                            > <Icon name='dropdown' />Past Appointments{activeIndex === 13 && state.permissions.schedulingModifyAppointments && <Icon name="plus" title="Add Appointment" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setShowAddAppointment(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 13}>
                                {activeIndex === 13 && <AppointmentList patientName={`${patient?.firstName || ""} ${patient?.lastName || ""}`} patientId={patient.id} allLocations={props.allLocations} aptType={'past'} keyword={keyword} pull={activeIndex == 13} refresh={refresh} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.paymentsViewInvoices && <>
                            <Accordion.Title
                                active={activeIndex === 6}
                                index={6}
                                onClick={e => { e.preventDefault(); setIndex(6) }}
                            > <Icon name='dropdown' />Open Balances{activeIndex === 6 && state.permissions.paymentsModifyInvoices && <Icon name="plus" title="Add Invoice for Patient" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setShowProcessPayment(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 6}>
                                {activeIndex === 6 && <OpenBalancesList refresh={() => { setRefresh(true); props.refresh() }} patientId={patient.id} keyword={keyword} pull={activeIndex === 6} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.paymentsViewSubscriptionsAndPlans && <>
                            <Accordion.Title
                                active={activeIndex === 7}
                                index={7}
                                onClick={e => { e.preventDefault(); setIndex(7) }}
                            > <Icon name='dropdown' />Payment Plans and Subscriptions
                            {/* {activeIndex === 7 && <Icon name="plus" title="Add Subscription Details" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setMembershipAdd(true) }} />} */}
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 7}>
                                {activeIndex === 7 && <PaymentPlanList patientId={patient.id} pull={activeIndex === 7} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.paymentsViewTransactions && <>
                            <Accordion.Title
                                active={activeIndex === 8}
                                index={8}
                                onClick={e => { e.preventDefault(); setIndex(8) }}
                            > <Icon name='dropdown' />Transaction History</Accordion.Title>
                            <Accordion.Content active={activeIndex === 8}>
                                {activeIndex === 8 && <TransactionHistoryList patientId={patient.id} keyword={keyword} pull={activeIndex === 8} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.patientViewCommunications && <>
                            <Accordion.Title
                                active={activeIndex === 9}
                                index={9}
                                onClick={e => { e.preventDefault(); setIndex(9) }}
                            > <Icon name='dropdown' />Communication History</Accordion.Title>
                            <Accordion.Content active={activeIndex === 9}>
                                {activeIndex === 9 && <CommunicationList patientId={patient.id} keyword={keyword} pull={activeIndex === 9} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.patientViewDocuments && <>
                            <Accordion.Title
                                active={activeIndex === 10}
                                index={10}
                                onClick={e => { e.preventDefault(); setIndex(10) }}
                            > <Icon name='dropdown' />Documents{activeIndex === 10 && state.permissions.patientModifyDocuments && <Icon patientId={patient.id} name="plus" title="Add Documents to Patient" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setShowAddDocuments(true) }} />}</Accordion.Title>
                            <Accordion.Content active={activeIndex === 10}>
                                {activeIndex === 10 && <DocumentList email={patient.email} patientId={patient.id} patient={patient} keyword={keyword} pull={activeIndex === 10} refresh={refresh} openModal={() => setShowAddDocuments(true)}/>}
                            </Accordion.Content>
                            </>}
                            {state.permissions.paymentsViewTransactions && <>
                            <Accordion.Title
                                active={activeIndex === 11}
                                index={11}
                                onClick={e => { e.preventDefault(); setIndex(11) }}
                            > <Icon name='dropdown' />Memberships</Accordion.Title>
                            <Accordion.Content active={activeIndex === 11}>
                                {activeIndex === 11 && <MembershipList patientId={patient.id} keyword={keyword} pull={activeIndex === 11} />}
                            </Accordion.Content>
                            </>}
                            {state.permissions.paymentsViewTransactions && <>
                            <Accordion.Title
                                active={activeIndex === 12}
                                index={12}
                                onClick={e => { e.preventDefault(); setIndex(12) }}
                            > <Icon name='dropdown' />Treatment Plans{activeIndex === 12 && <Icon name="plus" title="Add Treatment Plans" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setTreatmentPlansAdd(true) }} />}
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 12}>
                                {activeIndex === 12 && <TreatmentPlanList patient={patient}  keyword={keyword} refresh={refresh} pull={activeIndex === 12} />}
                            </Accordion.Content>
                            </>}
                            <Accordion.Title
                                active={activeIndex === 14}
                                index={14}
                                onClick={e => { e.preventDefault(); setIndex(14) }}
                            > <Icon name='dropdown' />Chart Notes History</Accordion.Title>
                            <Accordion.Content active={activeIndex === 14}>
                                {activeIndex === 14 && <ChartNotesHistoryTable patientId={patient.id} pull={activeIndex == 14}/>}
                            </Accordion.Content>
                            <Accordion.Title
                                active={activeIndex === 15}
                                index={15}
                                onClick={e => { e.preventDefault(); setIndex(15) }}
                            >
                                <Icon name='dropdown' />Soap Notes{activeIndex === 15 && <Icon name="plus" title="Add Soap Notes" className='btn p-0 m-0 float-right' onClick={e => { e.preventDefault(); setShowSoapNotesAdd(true) }} />}
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 15}>
                                {activeIndex === 15 && <SoapNotesList patientId={patient.id} pull={activeIndex == 15} />}
                            </Accordion.Content>


                            <TranscriptsPanel
                                patientId={patient.id}
                                open={activeIndex === 16}
                                onToggle={() => setIndex(16)}
                            />

                        </Accordion>
                    </div>}
                </div>
            }

            <ModalBox open={contactDetailsAdd} onClose={() => { setContactDetailsAdd(false) }} title="Edit Patient">
                <EditPatient id={patient.id} onClose={() => { props.refresh(); findPatient(); return setContactDetailsAdd(false); }} isModal />
            </ModalBox>

            <ModalBox open={noteAdd} onClose={() => { setNoteAdd(false) }} title="Add a Patient Note">
                <NoteAdd initialData={{ patientId: patient.id }} patient={patient} onClose={() => { props.refresh(); return setNoteAdd(false) }} isModal />
            </ModalBox>

            <ModalBox open={showAddAppointment} onClose={() => { setShowAddAppointment(false) }} title="Add Appointment">
                {showAddAppointment && <AddAppointmentForm initialData={{ patientId: patient.id }} onClose={() => setShowAddAppointment(false)} />}
            </ModalBox>
            <ModalBox open={showAddPaymentAccount} onClose={() => { setShowAddPaymentAccount(false) }} title="Add Patient Account">
                <PatientAccountAdd patientId={patient.id} onClose={() => { setRefresh(true); return setShowAddPaymentAccount(false) }} />
            </ModalBox>
            <ModalBox open={showProcessPayment} onClose={() => { setRefresh(true); return setShowProcessPayment(false); }} title="Add Invoice" size="fullscreen">
                {patient && <AddInvoice selectPatientDisabled initialData={{ patientId: patient.id }} onClose={() => { setRefresh(true); props.refresh(); return setShowProcessPayment(false); }} isModal />}
            </ModalBox>
            <ModalBox open={showAddForms} onClose={() => { setShowAddForms(false) }} title="Add Forms">
                <AddForms onClose={() => { setRefresh(true); props.refresh(); return setShowAddForms(false) }} patientId={patient.id} />
            </ModalBox>
            <ModalBox open={showAddDocuments} onClose={() => { setShowAddDocuments(false) }} title="Add Documents" size="tiny">
                <AddDocuments onClose={() => { setRefresh(true); props.refresh(); return setShowAddDocuments(false) }} patientId={patient.id} />
            </ModalBox>
            <ModalBox open={showOpt} onClose={() => { setShowOpt(false) }} title={`Opt ${patient.isOptIn === 1 ? 'Out of' : 'In to'} to text notifications`}>
                <PatientOptInOut patient={patient} onClose={() => { setShowOpt(false) }} refresh={() => {props.refresh()}}/>
            </ModalBox>
            <ModalBox open={treatmentPlansAdd} onClose={() => { setTreatmentPlansAdd(false) }} title="Add Treatment Plans">
                <TreatmentPlanAdd initialData={{ patientId: patient.id }} patient={patient} onClose={() => { setTreatmentPlansAdd(false) }} isModal />
            </ModalBox>
            <ModalBox open={showSoapNotesAdd} onClose={() => setShowSoapNotesAdd(false)} title="Add Soap Notes">
                <SoapNotesAdd patientId={patient.id}  onClose={() => { setShowSoapNotesAdd(false) }} isModal />
            </ModalBox>
            <ModalBox open={showCombinePatient} onClose={() => { setShowCombinePatient(false) }} title={`Combine Patient`}>
                <CombinePatients creditBalance={creditBalance} openBalance={balance} patient={patient} onClose={() => { setShowCombinePatient(false) }} refresh={() => { props.onCombinePatient() }} />
            </ModalBox>
        </div>
    )
}

export default PatientCard